/**
 * KC ATC Popup — sepete-ekleme anı önerisi (pilot: Carry One Pouch → The Rope)
 *
 * Entegrasyon: kc-bundle.js ile aynı desen. Bu script theme.liquid'de
 * cart-drawer.js'ten ÖNCE yer alır (defer sırası = belge sırası), submit'i
 * capture fazında yakalar ve anchor ürünse stopImmediatePropagation ile
 * tb-drawer'ın addFromForm akışını devre dışı bırakır. Sheet, drawer'ın
 * YERİNE onay ekranı olur. Rope eklenirse / "Sepeti gör" denirse drawer açılır.
 * Oturum başına 1 kez gösterilir; sonraki ATC'ler normal drawer akışına düşer.
 */
(function () {
  'use strict';
  if (window.__kcAtcPopupBound) return;
  window.__kcAtcPopupBound = true;

  var blob = document.getElementById('kc-atc-popup-data');
  var sheet = document.getElementById('kca-sheet');
  var overlay = document.getElementById('kca-overlay');
  if (!blob || !sheet || !overlay) return;

  var data;
  try { data = JSON.parse(blob.textContent); } catch (_) { return; }
  if (!data || !data.rope || !data.rope.variants || !data.rope.variants.length
      || !data.pouch || !data.pouch.variants) return;

  var SEEN_KEY = 'kc_atc_seen_' + (data.pouch && data.pouch.title ? 'carry-one' : 'x');
  var pouchVids = {};
  (data.pouch.variants || []).forEach(function (v) { pouchVids[String(v.vid)] = v; });

  var selRope = null;
  var scrollY = 0;
  var lastFocus = null;
  var heroLoaded = false;
  var pendingRefresh = null;

  function loadHero() {
    if (heroLoaded) return;
    var hero = document.getElementById('kca-hero-img');
    if (hero && hero.dataset.src) { hero.src = hero.dataset.src; heroLoaded = true; }
  }

  // K-06 (2026-10-02): mağaza biçimi "2.800,00 TL"; tasarruf tutarı kuruşsuz
  function money(cents) {
    try { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
    catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' TL'; }
  }
  function moneyTl(cents) {
    try { return Math.round(cents / 100).toLocaleString('tr-TR') + ' TL'; } catch (_) { return Math.round(cents / 100) + ' TL'; }
  }

  function drawer() { return window.kcCartDrawer || null; }

  /* ===== iOS-sağlam scroll kilidi: position:fixed + scrollY restore ===== */
  function lock() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = -scrollY + 'px';
    document.body.classList.add('kca-lock');
  }
  function unlock() {
    document.body.classList.remove('kca-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  /* ===== Sheet doldurma ===== */
  function buildSwatches() {
    var row = document.getElementById('kca-sw-row');
    if (!row) return;
    row.innerHTML = data.rope.variants.map(function (v) {
      return '<button type="button" class="kca-sw" data-vid="' + v.vid +
        '" style="--sw:' + v.hex + '" title="' + v.color + '" aria-label="' + v.color + '"></button>';
    }).join('');
  }

  function selectRope(vid) {
    var v = null;
    for (var i = 0; i < data.rope.variants.length; i++) {
      if (String(data.rope.variants[i].vid) === String(vid)) { v = data.rope.variants[i]; break; }
    }
    if (!v) v = data.rope.variants[0];
    selRope = v;
    var row = document.getElementById('kca-sw-row');
    if (row) {
      Array.prototype.forEach.call(row.children, function (b) {
        b.classList.toggle('is-sel', String(b.dataset.vid) === String(v.vid));
      });
    }
    var was = document.getElementById('kca-was');
    if (was) was.textContent = money(v.was);
    var save = document.getElementById('kca-save');
    if (save) {
      /* compare_at yoksa/indirim anlamsızsa −₺0 rozeti gösterme */
      var diff = v.was - data.offer;
      save.textContent = '−' + moneyTl(diff);
      save.style.display = diff > 0 ? '' : 'none';
    }
    var img = document.getElementById('kca-rope-img');
    if (img && v.img) img.src = v.img;
  }

  function fillFor(pouchVariant) {
    var name = document.getElementById('kca-pouch-name');
    var thumb = document.getElementById('kca-pouch-img');
    var vTitle = pouchVariant && pouchVariant.title !== 'Default Title' ? pouchVariant.title : '';
    if (name) name.textContent = data.pouch.title + (vTitle ? ' — ' + vTitle : '');
    if (thumb && pouchVariant && pouchVariant.img) thumb.src = pouchVariant.img;

    var ropeColor = (data.colorMap && data.colorMap[vTitle]) || data.rope.variants[0].color;
    var match = data.rope.variants.filter(function (v) { return v.color === ropeColor; })[0];
    var label = document.getElementById('kca-sw-label');
    if (match) {
      /* Eşleşen renk stokta — "X ile — Renk" iddiası doğru */
      if (label) label.textContent = vTitle ? (vTitle + ' ile — ' + match.color) : 'Renk';
    } else {
      /* Eşleşen renk tükenmiş — yanlış eşleştirme iddiası yapma */
      match = data.rope.variants[0];
      if (label) label.textContent = 'Rengini seç';
    }
    selectRope(match.vid);
  }

  /* ===== Aç / kapa ===== */
  function open() {
    loadHero();
    var cta = document.getElementById('kca-add');
    if (cta) { cta.disabled = false; cta.textContent = 'Sepete ekle — ' + money(data.offer); }
    lastFocus = document.activeElement;
    lock();
    overlay.classList.add('is-open');
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      var c = document.getElementById('kca-close');
      if (c) { try { c.focus({ preventScroll: true }); } catch (_) { c.focus(); } }
    });
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (_) {}
  }

  function close(thenDrawer) {
    overlay.classList.remove('is-open');
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    unlock();
    if (lastFocus && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (_) {}
    }
    lastFocus = null;
    if (thenDrawer && drawer()) {
      /* Pouch-add refresh'i hâlâ uçuştaysa bitmesini bekle — drawer bayat açılmasın */
      Promise.resolve(pendingRefresh).then(function () { drawer().open(); });
    }
  }

  function seen() {
    try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (_) { return false; }
  }

  /* ===== ATC intercept (capture, cart-drawer.js'ten önce kayıtlı) ===== */
  function bindIntercept() {
    document.body.addEventListener('submit', function (e) {
      var f = e.target;
      if (!(f instanceof HTMLFormElement)) return;
      if (!f.action || f.action.indexOf('/cart/add') === -1) return;
      var fd = new FormData(f);
      var vid = String(fd.get('id') || '');
      if (!pouchVids[vid]) return;          /* anchor değil → bundle/drawer akışı */
      if (seen()) return;                   /* oturumda gösterildi → drawer akışı */

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      handlePouchAdd(f, fd, pouchVids[vid]);
    }, true);
  }

  function handlePouchAdd(form, fd, pouchVariant) {
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ekleniyor'; }
    loadHero(); /* istek uçarken hero inmeye başlasın — sheet boş kutuyla açılmasın */

    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        /* Cap'i HEMEN set et: open() patlasa bile ikinci tık drawer akışına
           düşer, asla ikinci POST atılmaz (çift ekleme koruması). */
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (_) {}
        var d = drawer();
        pendingRefresh = d ? d.refresh() : null;
        fillFor(pouchVariant);
        open();
      })
      .catch(function () {
        /* POST'un akıbeti belirsiz (ağ hatası sunucuya ulaşmış olabilir).
           YENİ POST ATMA — çift ekleme riski. Drawer'ı güncel durumla aç:
           eklendiyse görünür, eklenmediyse kullanıcı oradan tekrar dener. */
        var d = drawer();
        if (d) { d.refresh().then(function () { d.open(); }); }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
      });
  }

  /* ===== Rope ekleme ===== */
  function addRope() {
    if (!selRope) return;
    var cta = document.getElementById('kca-add');
    if (cta) { cta.disabled = true; cta.textContent = 'Ekleniyor'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(selRope.vid, 10), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('rope add failed'); return r.json(); })
      .then(function () {
        var d = drawer();
        var p = d ? d.refresh() : Promise.resolve();
        return Promise.resolve(p).then(function () { close(true); });
      })
      .catch(function () {
        if (cta) { cta.disabled = false; cta.textContent = 'Sepete ekle — ' + money(data.offer); }
        var d = drawer();
        if (d && d.toast) d.toast('Eklenemedi, tekrar dener misin?');
      });
  }

  /* ===== Swipe-down ile kapatma (mobil) =====
     Sheet scroll'u en üstteyken aşağı çekiş sheet'i sürükler; 110px eşiği
     aşılırsa kapanır, aşılmazsa yerine oturur. İçerik scroll'uyla çakışmaz:
     scrollTop > 0 iken sürükleme hiç başlamaz. */
  function bindSwipe() {
    var startY = 0, dy = 0, dragging = false, atTop = false;
    sheet.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 900) return;
      atTop = sheet.scrollTop <= 0;
      startY = e.touches[0].clientY;
      dy = 0;
      dragging = false;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (window.innerWidth >= 900 || !atTop) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 8) {
        dragging = true;
        sheet.style.transition = 'none';
        sheet.style.transform = 'translateY(' + dy + 'px)';
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });
    sheet.addEventListener('touchend', function () {
      if (!dragging) return;
      sheet.style.transition = '';
      if (dy > 110) {
        close(false);
        requestAnimationFrame(function () { sheet.style.transform = ''; });
      } else {
        sheet.style.transform = '';
      }
      dragging = false;
      dy = 0;
    });
  }

  /* ===== Events ===== */
  function bindUI() {
    overlay.addEventListener('click', function () { close(false); });
    document.getElementById('kca-close').addEventListener('click', function () { close(false); });
    document.getElementById('kca-decline').addEventListener('click', function () { close(false); });
    document.getElementById('kca-goto-cart').addEventListener('click', function () { close(true); });
    document.getElementById('kca-add').addEventListener('click', addRope);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(false);
    });
    var row = document.getElementById('kca-sw-row');
    if (row) {
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.kca-sw');
        if (b) selectRope(b.dataset.vid);
      });
    }
  }

  buildSwatches();
  bindUI();
  bindSwipe();
  bindIntercept();
})();
